// extracted by mini-css-extract-plugin
module.exports = {"c":"styles_c__6saF9","front":"styles_front__3bok9","back":"styles_back__2vaNg","container":"styles_container__16hzh"};